import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
  ContentFooter,
  ContentSocialIcon,
  GlobalFooterComponent
} from '@com-delta-idp/mnx-sitewide-footer-ui';
import {
  AnalyticsDataPopulateService,
  AnalyticsService,
  SPECIAL_CHARACTERS_REGEX
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { HeaderFooterFacadeService } from '../../data-access/facades/header-footer.facade.service';

@Component({
  selector: 'idp-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, PushPipe, GlobalFooterComponent]
})
export class FooterComponent implements OnInit {
  @Input() displaySearch = true;
  @Input() trimFooter = false;
  @Input() disableLangSelection = false;
  @Input() isLightFooter = false;
  @Input() disableBackgroundColor = false;
  content: ContentFooter = {} as ContentFooter;
  footerFacadeService = inject(HeaderFooterFacadeService);
  analytics = inject(AnalyticsService);
  analyticsDataPopulate = inject(AnalyticsDataPopulateService);
  emptyFooterContent: ContentFooter = {} as ContentFooter;

  ngOnInit(): void {
    this.footerFacadeService.init();
  }

  afterViewCheckEvent(): void {
    this.footerFacadeService.footerAfterViewCheck();
  }

  search($event: string, element?: HTMLElement): void {
    const baseUrl = (
      this.footerFacadeService.siteSearchUrl || '/sitesearch?searchTerm='
    ).replace(/^'+|'+$/g, '');
    const url =
      baseUrl +
      encodeURIComponent($event.replace(SPECIAL_CHARACTERS_REGEX, ''));
    if (element) {
      this.onSearchAnalytics({ element, searchTerm: $event });
    }
    window.location.href = url;
  }

  onSearchAnalytics(event: { element: HTMLElement; searchTerm: string }): void {
    const searchTermData = event.searchTerm
      ? {
          search: {
            term: event.searchTerm,
            type: event.element.getAttribute('data-search-type') ?? ''
          }
        }
      : undefined;
    this.analyticsDataPopulate.populateAnalyticsData(
      event.element,
      undefined,
      searchTermData
    );
  }

  iconClick(icon: ContentSocialIcon): void {
    window.open(icon.iconLink, '_blank');
  }

  onSearchInputAnalytics(element: HTMLElement): void {
    this.analyticsDataPopulate.populateAnalyticsData(element);
  }

  analyticsCall(element: HTMLElement): void {
    this.analyticsDataPopulate.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }
}
